import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import RankerXLink from "components/RankerXLink";
import {
	Table,
	Card,
	Form,
	Button,
	Row,
	Icon,
	Popconfirm,
	Spin,
	Input,
	InputNumber,
	Tooltip,
	Tabs,
	Menu,
	Dropdown,
	Progress,
} from "antd";

import BasicLayout from "layouts/BasicLayout";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import ImportFilesDialog from "components/ImportFilesDialog";
import DownloadKMArticlesDialog from "./components/DownloadKMArticlesDialog";
import OpenAIDrawer from "./components/OpenAIDrawer";
import { locationPrefix } from "common/general";
import _ from "lodash";
import co from "co";

const MenuItem = Menu.Item;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class SettingsForm extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.props.form.validateFieldsAndScroll((err, vals) => {
				resolve(err);
			});
		});
	};
	render() {
		return (
			<Card>
				<Form>
					<FormItem label="Protected words (comma separated) for spinner">
						{this.props.form.getFieldDecorator("wordsNottobeChanged")(
							<Input type="text" />
						)}
					</FormItem>
					<FormItem label="Number of times an article can be used. Zero (0) means unlimited">
						{this.props.form.getFieldDecorator("maxUsagePerArticle", {
							rules: [
								{
									required: true,
									type: "integer",
									min: 0,
									message: "Required and greater or equal to 0"
								}
							]
						})(<InputNumber />)}
					</FormItem>
					<Button
						type="primary"
						onClick={this.props.saveSettings}
						loading={this.props.ui.savingSettings}
					>
						Save
					</Button>
				</Form>
			</Card>
		);
	}
}

@inject("rootStore")
@observer
export default class ContentGroupPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedRowKeys: []
		};
	}

	saveSettings = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		co(
			function* () {
				let response = yield this.internalForm.validateForm();
				// console.log("Validating result");
				// console.log(response);
				if (response == null) {
					contentGroupStore.saveSettings();
				}
			}.bind(this)
		);
	};

	mapPropsToFields() {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		let contentGroup = contentGroupStore.stateForm;
		let result = {
			maxUsagePerArticle: Form.createFormField(contentGroup.maxUsagePerArticle),
			wordsNottobeChanged: Form.createFormField(
				contentGroup.wordsNottobeChanged
			)
		};
		return result;
	}

	onFieldsChange = _.debounce(changedFields => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.formChanged(changedFields);
	}, 200);

	componentWillUnmount = () => {
		this.onFieldsChange.cancel();
	};

	deleteArticles = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.remoteDeleteArticles(this.state.selectedRowKeys);
	};

	addNewArticle = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		const contentGroup = contentGroupStore.contentGroup;
		window.open(locationPrefix + "/new-article/" + contentGroup.id, "_self");
	};

	showImportArticlesDialog = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.showImportArticlesDialog();
	};

	hideImportArticlesDialog = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.hideImportArticlesDialog();
	};

	showImportArticlesByTitleDialog = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.showImportArticlesByTitleDialog();
	};

	hideImportArticlesByTitleDialog = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.hideImportArticlesByTitleDialog();
	};

	showDownloadKMArticlesDialog = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;
		contentGroupStore.showDownloadKMArticlesDialog();
	};

	hideDownloadKMArticlesDialog = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.hideDownloadKMArticlesDialog();
	};

	updateKMCampaigns = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.updateKMCampaigns();
	}

	downloadKMArticles = (kmCampaignId) => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.downloadKMArticles(kmCampaignId);
	}

	showOpenAIDrawer = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.showOpenAIDrawer();
	};

	hideOpenAIDrawer = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.hideOpenAIDrawer();
	};

	handleGenerateArticlesClick = ({ key }) => {
		if (key == "openAI") {
			this.showOpenAIDrawer();
		}
	};

	generateOpenAIArticles = payload => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.generateArticles(payload);
	};

	stopGeneratingArticles = () => {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		contentGroupStore.stopGeneratingArticles();
	}

	render() {
		const {
			rootStore: { contentGroupStore }
		} = this.props;

		const ui = contentGroupStore.ui;
		const kmCampaigns = contentGroupStore.kmCampaigns;

		const columns = [
			{
				title: "ID",
				dataIndex: "id",
				width: 120,
				defaultSortOrder: "descend",
				sorter: (a, b) => a.id - b.id
			},
			{
				title: "Title",
				dataIndex: "title",
				render: (text, record) => {
					let displayedText = text;
					if (text.length > 100) {
						displayedText = displayedText.substring(0, 100) + "...";
					}
					return (
						<RankerXLink
							routeName="article"
							params={{ id: record.id.toString() }}
						>
							{displayedText}
						</RankerXLink>
					);
				}
			},
			{
				title: "Usage Count",
				width: 120,
				dataIndex: "usageCount"
			}
		];

		const rowSelection = {
			onChange: (selectedRowKeys, selectedRows) => {
				this.setState({ selectedRowKeys });
			},
			getCheckboxProps: record => ({
				id: record.id.toString()
			})
		};

		let spinning =
			ui.loadingContentGroup == true || ui.deletingArticles == true;

		const articles = toJS(contentGroupStore.articles);

		const breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/"
			},
			{
				title: "Content Groups",
				href: locationPrefix + "/content-groups"
			},
			{
				title: "Content Group: " + contentGroupStore.contentGroup.name
			}
		];

		let generateArticlesMenu = (
			<Menu onClick={this.handleGenerateArticlesClick}>
				<Menu.Item key="openAI">OpenAI</Menu.Item>
				{/* <Menu.Item key="articleForgeArticle">Article Forge Article</Menu.Item>
				<Menu.Item key="articleBuilder">ArticleBuilder.net</Menu.Item> */}
			</Menu>
		);

		let generatorJobSection = <></>;
		if (contentGroupStore.generatorJob != null) {
			let progress = contentGroupStore.generatorJob.progress;
			let numberOfArticles = contentGroupStore.generatorJob.numberOfArticles;						
			let percent = Math.round(progress / numberOfArticles * 100);
			if (contentGroupStore.generatorJob.completed != true && contentGroupStore.generatorJob.isStopped != true) {
				generatorJobSection =
				(<Row>
					<Card size="small" title="Generating Articles" style={{ width: "50%" }}>
						<span style={{marginRight: 20}}>Provider: OpenAI</span><Button type="primary" onClick={this.stopGeneratingArticles}>Cancel</Button>
						<Progress percent={percent} size="small" />						
					</Card>
				</Row>);
			} 			
		}
		return (
			<Fragment>
				{ui.loadingContentGroup == true ? (
					""
				) : (
					<PageHeaderLayout
						breadcrumbList={breadcrumbList}
						title={"Content Group: " + contentGroupStore.contentGroup.name}
					>
						<ImportFilesDialog
							dialogVisible={ui.importArticlesDialogVisible}
							uploadingFiles={ui.importingArticles}
							hideDialog={this.hideImportArticlesDialog}
							multiple={true}
							title="Import Articles"
							hint="You can import multiple article files or a ZIP file"
							uploadUrl={
								"/rest/upload_raw_articles/" + contentGroupStore.contentGroup.id
							}
						/>
						<ImportFilesDialog
							dialogVisible={ui.importArticlesByTitleDialogVisible}
							uploadingFiles={ui.importingArticlesByTitle}
							hideDialog={this.hideImportArticlesByTitleDialog}
							multiple={true}
							title="Import Articles - Title is the File Name"
							hint="You can import multiple article files or a ZIP file. Title of the articles is the file name"
							uploadUrl={
								"/rest/upload_raw_articles_file_name_title/" +
								contentGroupStore.contentGroup.id
							}
						/>
						<DownloadKMArticlesDialog
							dialogVisible={ui.downloadKMArticlesDialogVisible}
							downloadingKMArticles={ui.downloadingKMArticles}
							downloadKMArticles={this.downloadKMArticles}
							hideDialog={this.hideDownloadKMArticlesDialog}
							updateKMCampaigns={this.updateKMCampaigns}
							updatingKMCampaigns={ui.updatingKMCampaigns}
							kmCampaigns={kmCampaigns}
						/>

						<OpenAIDrawer
							ui={ui}
							hideDrawer={this.hideOpenAIDrawer}
							generateArticles={
								this.generateOpenAIArticles
							}
							contentGroupId={contentGroupStore.contentGroup.id}
						/>

						<SettingsForm
							fields={this.mapPropsToFields()}
							ui={ui}
							onFieldsChange={this.onFieldsChange}
							saveSettings={this.saveSettings}
							wrappedComponentRef={internalForm => {
								if (internalForm != null) {
									this.internalForm = internalForm;
								}
							}}
						/>
						<br />
						<Card>
							<Spin spinning={spinning}>
								{generatorJobSection}
								<Row>
									<Form layout="inline" style={{ marginBottom: 8 }}>
										<FormItem>
											<Dropdown overlay={generateArticlesMenu}>
												<Button type="primary">
													Generate Articles <Icon type="down" />
												</Button>
											</Dropdown>
										</FormItem>
										<FormItem>
											<Tooltip title="Add New Article">
												<Button type="primary" onClick={this.addNewArticle}>
													<Icon type="plus-square-o" />
												</Button>
											</Tooltip>
										</FormItem>
										<FormItem>
											<Popconfirm
												title="Do you want to delete the selected articles?"
												place
												ment="bottom"
												onConfirm={this.deleteArticles}
											>
												<Button
													type="primary"
													disabled={this.state.selectedRowKeys.length == 0}
												>
													<Icon type="delete" />
												</Button>
											</Popconfirm>
										</FormItem>
										<FormItem>
											<Tooltip title="Upload Article">
												<Button
													type="primary"
													onClick={this.showImportArticlesDialog}
												>
													<Icon type="upload" />
												</Button>
											</Tooltip>
										</FormItem>
										<FormItem>
											<Tooltip title="Upload Article - Title is File Name">
												<Button
													type="primary"
													onClick={this.showImportArticlesByTitleDialog}
												>
													<Icon type="cloud-upload" />
												</Button>
											</Tooltip>
										</FormItem>
										<FormItem>
											<Tooltip title="Download Articles from Kontent Machine">
												<Button
													type="primary"
													onClick={this.showDownloadKMArticlesDialog}
												>
													<Icon type="cloud-download" />
												</Button>
											</Tooltip>
										</FormItem>
									</Form>
								</Row>
								<Row>
									<Table
										rowKey="id"
										rowSelection={rowSelection}
										columns={columns}
										dataSource={articles}
										pagination={{
											pageSize: 100
										}}
									/>
								</Row>
							</Spin>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}
